import { stages } from 'bundles/apex/deals/config';

export function getOrderedStages(customStages) {
  // apart from ordering, we also want to igonore any stages that are not in the customStages object
  const ordered = Object.values(stages).filter(stage => Object.keys(customStages).includes(stage.key));

  for (const [i, stage] of ordered.entries()) {
    if (customStages[stage.key]?.label) {
      ordered[i] = { ...ordered[i], label: customStages[stage.key].label };
    }
  }

  return ordered;
}
